// import React, { useState, useEffect, useRef } from "react";
// import { Search, ChevronDown, ChevronUp } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { filterData } from "./data";
// import { motion, AnimatePresence } from "framer-motion";
// import "../assests/CSS/FilterBar.css";

// const servicesList = filterData?.services || [];
// const dropdownData = Object.fromEntries(
//   Object.entries(filterData || {}).filter(([key]) => key !== "services" && key !== "countries")
// );
// const countriesList = Object.keys(filterData?.countries || {});

// const FilterBar = () => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [placeholderIndex, setPlaceholderIndex] = useState(0);
//   const [animatedPlaceholder, setAnimatedPlaceholder] = useState(servicesList[0] || "");
//   const [fade, setFade] = useState(true);
//   const [suggestions, setSuggestions] = useState([]);
//   const [openDropdowns, setOpenDropdowns] = useState({});
//   const dropdownRefs = useRef({});
//   const navigate = useNavigate();

//   // Animate placeholder text
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setFade(false);
//       setTimeout(() => {
//         const nextIndex = (placeholderIndex + 1) % servicesList.length;
//         setPlaceholderIndex(nextIndex);
//         setAnimatedPlaceholder(servicesList[nextIndex]);
//         setFade(true);
//       }, 200);
//     }, 2000);
//     return () => clearInterval(interval);
//   }, [placeholderIndex]);

//   // Handle search input change
//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     if (value.trim()) {
//       const filtered = servicesList.filter((service) =>
//         service.toLowerCase().includes(value.toLowerCase())
//       );
//       setSuggestions(filtered);
//     } else {
//       setSuggestions([]);
//     }
//   };

//   // Click on suggestion
//   const handleSuggestionClick = (suggestion) => {
//     setSearchTerm(suggestion);
//     setSuggestions([]);
//     navigateToFilterResult(suggestion, null);
//   };

//   // Handle dropdown toggle
//   const toggleDropdown = (key, isOpen) => {
//     setOpenDropdowns((prev) => ({
//       ...prev,
//       [key]: isOpen,
//     }));
//   };

//   // Navigate to Insights page with selected filter
//   const navigateToFilterResult = (service, country) => {
//     const data = {
//       search: service || searchTerm,
//       location: country || "",
//     };
//     navigate("/insights", { state: { searchData: data } });
//   };

//   return (
//     <div className="filter-bar">
//       <div className="search-select">
//         <Search size={18} className="search-icon" />
//         <div className="search-wrapper">
//           <input
//             type="text"
//             placeholder={animatedPlaceholder}
//             className={`search-input ${fade ? "fade-in" : "fade-out"}`}
//             value={searchTerm}
//             onChange={handleSearchChange}
//           />
//           <AnimatePresence>
//             {suggestions.length > 0 && (
//               <motion.ul
//                 className="suggestions-list"
//                 initial={{ opacity: 0, y: -10 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -10 }}
//                 transition={{ duration: 0.2 }}
//               >
//                 {suggestions.map((item, index) => (
//                   <li
//                     key={index}
//                     onClick={() => handleSuggestionClick(item)}
//                     className="suggestion-item"
//                   >
//                     {item}
//                   </li>
//                 ))}
//               </motion.ul>
//             )}
//           </AnimatePresence>
//         </div>
//       </div>

//       {Object.entries(dropdownData).map(([key, options]) => (
//         <div className="dropdown-container" key={key}>
//           <select
//             className={`filter-dropdown ${key}`}
//             ref={(el) => (dropdownRefs.current[key] = el)}
//             onFocus={() => toggleDropdown(key, true)}
//             onBlur={() => toggleDropdown(key, false)}
//             onChange={(e) => navigateToFilterResult(searchTerm, e.target.value)}
//           >
//             <option>
//               {key.replace(/([A-Z])/g, " $1").replace(/^\w/, (c) => c.toUpperCase())}
//             </option>
//             {options.map((opt, i) => (
//               <option key={i} value={opt}>
//                 {opt}
//               </option>
//             ))}
//           </select>
//           <div className="dropdown-icon">
//             {openDropdowns[key] ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
//           </div>
//         </div>
//       ))}

//       {/* Country dropdown */}
//       {/* <div className="dropdown-container">
//         <select
//           className="filter-dropdown country"
//           onChange={(e) => navigateToFilterResult(searchTerm, e.target.value)}
//         >
//           <option>Select Country</option>
//           {countriesList.map((country, i) => (
//             <option key={i} value={country}>
//               {country}
//             </option>
//           ))}
//         </select>
//       </div> */}
//     </div>
//   );
// };

// export default FilterBar;




import React, { useState, useEffect, useRef } from "react";
import { Search, ChevronDown, ChevronUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { filterData } from "./data";
import { motion, AnimatePresence } from "framer-motion";
import "../assests/CSS/FilterBar.css";

const servicesList = filterData?.services || [];
const dropdownData = Object.fromEntries(
  Object.entries(filterData || {}).filter(
    ([key]) => key !== "services" && key !== "countries" && key !== "country"
  )
);
const countriesList = filterData?.country || [];

const FilterBar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [animatedPlaceholder, setAnimatedPlaceholder] = useState(
    servicesList[0] || ""
  );
  const [fade, setFade] = useState(true);
  const [suggestions, setSuggestions] = useState([]);
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [selectedCountry, setSelectedCountry] = useState(""); 
  const dropdownRefs = useRef({});
  const navigate = useNavigate();

 
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        const nextIndex = (placeholderIndex + 1) % servicesList.length;
        setPlaceholderIndex(nextIndex);
        setAnimatedPlaceholder(servicesList[nextIndex]);
        setFade(true);
      }, 200);
    }, 2000);
    return () => clearInterval(interval);
  }, [placeholderIndex]);

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim()) {
      const filtered = servicesList.filter((service) =>
        service.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  };

  // Click on suggestion
  const handleSuggestionClick = (suggestion) => {
    setSearchTerm(suggestion);
    setSuggestions([]);
    navigateToFilterResult(suggestion, selectedCountry); 
  };

  // Handle dropdown toggle
  const toggleDropdown = (key, isOpen) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [key]: isOpen,
    }));
  };

  
  const navigateToFilterResult = (service, country) => {
    const data = {
      search: service || searchTerm,
      location: country ?? selectedCountry, 
    };
    navigate("/insights", { state: { searchData: data } });
  };

  return (
    <div className="filter-bar">
      {/* Search Input */}
      <div className="search-select">
        <Search size={18} className="search-icon" />
        <div className="search-wrapper">
          <input
            type="text"
            placeholder={animatedPlaceholder}
            className={`search-input ${fade ? "fade-in" : "fade-out"}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <AnimatePresence>
            {suggestions.length > 0 && (
              <motion.ul
                className="suggestions-list"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
              >
                {suggestions.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handleSuggestionClick(item)}
                    className="suggestion-item"
                  >
                    {item}
                  </li>
                ))}
              </motion.ul>
            )}
          </AnimatePresence>
        </div>
      </div>

{/* Country Dropdown */}
<div className="dropdown-container">
  <select
    className="filter-dropdown country"
    value={selectedCountry}
    onFocus={() => setOpenDropdowns((prev) => ({ ...prev, country: true }))}
    onBlur={() => setOpenDropdowns((prev) => ({ ...prev, country: false }))}
    onChange={(e) => {
      setSelectedCountry(e.target.value);
      navigateToFilterResult(searchTerm, e.target.value); 
    }}
  >
    <option value="">Select Country</option>
    {countriesList.map((country, i) => (
      <option key={i} value={country}>
        {country}
      </option>
    ))}
  </select>
  <div className="dropdown-icon">
    {openDropdowns["country"] ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
  </div>
</div>


      {/* Other Filter Dropdowns */}
      {Object.entries(dropdownData).map(([key, options]) => (
        <div className="dropdown-container" key={key}>
          <select
            className={`filter-dropdown ${key}`}
            ref={(el) => (dropdownRefs.current[key] = el)}
            onFocus={() => toggleDropdown(key, true)}
            onBlur={() => toggleDropdown(key, false)}
            onChange={(e) =>
              navigateToFilterResult(searchTerm, selectedCountry) // <- don't reset country
            }
          >
            <option>
              {key.replace(/([A-Z])/g, " $1").replace(/^\w/, (c) =>
                c.toUpperCase()
              )}
            </option>
            {options.map((opt, i) => (
              <option key={i} value={opt}>
                {opt}
              </option>
            ))}
          </select>
          <div className="dropdown-icon">
            {openDropdowns[key] ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </div>
        </div>
      ))}


    </div>
  );
};

export default FilterBar;
